<div class="minimal-modal-wrapper p-4 text-center">
    <button type="button" class="btn-close-minimal" (click)="activeModal.dismiss('cancel')" aria-label="Close">
        <span class="material-symbols-outlined">close</span>
    </button>

    <div class="icon-container mb-3">
        <div class="icon-shape warning-shape">
            <span class="material-symbols-outlined">
                @if (conflictType === 'HASH_CONFLICT') { file_copy } @else { warning }
            </span>
        </div>
    </div>

    <h3 class="modal-title-clean">
        @if (conflictType === 'HASH_CONFLICT') {
            File Identici Rilevati
        } @else {
            File Esistenti Rilevati
        }
    </h3>
    
    <p class="modal-text mb-3">
        @if (conflictType === 'HASH_CONFLICT') {
            Sono stati rilevati <strong>{{ duplicatesList.length }}</strong> file con <strong>contenuto identico</strong> a documenti già processati nel sistema.
        } @else {
            Sono stati rilevati <strong>{{ duplicatesList.length }}</strong> file con lo stesso percorso di documenti già esistenti, ma con <strong>contenuto diverso</strong> (possibili versioni aggiornate).
        }
    </p>
    
    <div class="duplicates-scroll-area text-start mb-4">
        @for (conflict of duplicatesList; track conflict.incomingFile) {
            <div class="duplicate-item">
                <span class="material-symbols-outlined file-icon">description</span>
                <div class="file-info w-100">
                    <span class="file-name">{{ getFileName(conflict.incomingFile) }}</span>
                    <span class="file-path mb-1">{{ conflict.incomingFile }}</span>
                    
                    @if (conflictType === 'HASH_CONFLICT') {
                        <div class="mt-2 p-2 rounded" style="background-color: #fffbeb; border: 1px solid #fde68a;">
                            <div class="d-flex align-items-center gap-1 mb-1">
                                <span class="material-symbols-outlined" style="font-size: 16px; color: #d97706;">info</span>
                                <span style="font-size: 0.8rem; font-weight: 600; color: #d97706;">File identico esistente:</span>
                            </div>
                            <span class="file-name d-block" style="font-size: 0.85rem; color: #92400e;">
                                {{ getFileName(conflict.existingFile) }}
                            </span>
                            <span class="file-path d-block" style="font-size: 0.75rem; color: #b45309;">
                                {{ conflict.existingFile }}
                            </span>
                        </div>
                    }
                </div>
            </div>
        }
    </div>

    <div class="action-selector text-start mb-4">
        <label for="duplicateAction" class="form-label fw-bold mb-2" style="color: #334155; font-size: 0.95rem;">
            Come vuoi procedere?
        </label>
        <select id="duplicateAction" class="form-select custom-select shadow-sm" [(ngModel)]="selectedAction">
            
            @if (!allDuplicates) {
                <option value="ignore">Ignora questi file (processa solo i nuovi documenti)</option>
            }
            
            @if (conflictType === 'HASH_CONFLICT') {
                <option value="replace">Sostituisci (elimina i file precedenti e tieni questi nei nuovi percorsi)</option>
            } @else {
                <option value="replace">Aggiorna versione (sovrascrivi i file esistenti con i nuovi)</option>
            }
            
            @if (canKeepBoth) {
                <option value="keep">Mantieni entrambi (rinomina automaticamente i nuovi file)</option>
            }
        </select>
    </div>

    <div class="modal-actions d-flex justify-content-center gap-3">
        <button type="button" class="btn-action btn-cancel" (click)="activeModal.dismiss('cancel')">
            Annulla
        </button>
        <button type="button" class="btn-action btn-confirm" (click)="confirm()">
            Conferma operazione
        </button>
    </div>
</div>